const PageList = {
  calculator: "calculator",
  applyForms: "applyForms",
};

export default PageList;
